export const RECEIVE_HISTORY = 'RECEIVE_HISTORY'
export const CLEAR_HISTORY = 'CLEAR_HISTORY'
export const RECEIVE_HISTORY_ERROR = 'RECEIVE_HISTORY_ERROR'
